import Cookies from 'js-cookie';
import { getBaseUrl } from './baseUrl';
import { parseJSON } from './utils';

export class RequestError extends Error {
  status: number;
  response: Response;

  constructor(response: Response) {
    super(`HTTP error! Status: ${response.status}`);
    this.name = 'RequestError';
    this.status = response.status;
    this.response = response;
  }
}

const request = async (/** @type {string} */ url: string, options: any = {}, isFile: boolean = false) => {
  const authu = Cookies.get('authu');
  const baseUrl = getBaseUrl();
  const fullUrl = `${baseUrl}${url}`;
  // Set the headers conditionally based on the content type
  const headers: any = {
    ...(authu ? { Authorization: 'Bearer ' + authu } : {}),
    ...options.headers, // Allow overriding or adding custom headers
  };

  let body: any = undefined;

  // Only set body for non-GET requests
  if (options.method !== 'GET' && options.method !== 'HEAD') {
    if (isFile) {
      // If handling file uploads, expect options.body to be FormData
      body = options.body;
    } else {
      headers['Content-Type'] = 'application/json; charset=UTF-8';
      body = options.body || {};
    }
  }

  const config: any = {
    credentials: 'include',
    ...options,
    headers,
  };

  // Only add body to config if it's defined
  if (body !== undefined) {
    config.body = body;
  }

  const response = await fetch(fullUrl, config);

  if (!response.ok) {
    throw new RequestError(response);
  }

  return isFile ? response : parseJSON(response);
};

export default request;
